import React, { createContext, useContext, useEffect, useState } from 'react';
import { CODE_TO_REGION, getCountryContent } from '../data/countryContent';

const CountryContext = createContext(null);
const STORAGE_KEY = 'mf_country';

export const CountryProvider = ({ children }) => {
  // Returning visitors with an explicit choice load it synchronously (no flash).
  // First-time visitors default to US (matches the prerendered HTML) until geo resolves.
  const [region, setRegionState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'US'; } catch { return 'US'; }
  });
  const [manual] = useState(() => {
    try { return !!localStorage.getItem(STORAGE_KEY); } catch { return false; }
  });

  useEffect(() => {
    if (manual) return; // explicit choice wins — never override with geo
    let cancelled = false;
    fetch('https://ipwho.is/?fields=country_code')
      .then((r) => r.json())
      .then((d) => {
        if (cancelled) return;
        setRegionState(CODE_TO_REGION[d && d.country_code] || 'GLOBAL');
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [manual]);

  const setRegion = (key) => {
    setRegionState(key);
    try { localStorage.setItem(STORAGE_KEY, key); } catch { /* ignore */ }
  };

  return (
    <CountryContext.Provider value={{ region, setRegion, content: getCountryContent(region) }}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCountry = () => {
  const ctx = useContext(CountryContext);
  if (!ctx) return { region: 'US', setRegion: () => {}, content: getCountryContent('US') };
  return ctx;
};
